import { Alert } from "antd";
import { useTranslation } from "react-i18next";
import { Map, MarkerData, PolyLineData } from "../../map/Map";
import { Maximizable } from "../../Maximizable";

interface MapDetailsProps {
  isLoading: boolean;
  markers: MarkerData[];
  polyLines?: PolyLineData[];
  alertMessage?: string;
  updateBounds?: boolean;
}

export function MapDetails({
  isLoading,
  markers,
  polyLines,
  alertMessage,
  updateBounds,
}: MapDetailsProps) {
  const { t } = useTranslation();

  return (
    <Maximizable>
      {(!markers || (markers.length === 0 && !isLoading)) && (
        <Alert
          message={alertMessage ? alertMessage : t("no-position")}
          type="info"
          showIcon
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
      )}
      <Map
        markers={markers}
        polylines={polyLines}
        isLoading={isLoading}
        updateBounds={updateBounds}
      />
    </Maximizable>
  );
}
